<template lang="pug">
  v-container.fill-height(fluid)
    v-row(align="center" justify="center")
      v-col(cols="12" sm="8" md="4")
        v-card.elevation-12(light color="whitesmoke")
          v-card-title.d-flex.justify-center()
            v-img(src="@/assets/images/arba_logo.png" max-width="170")
          v-card-text
            v-form
              v-text-field(v-model="username" label='Login' name='login' prepend-icon='mdi-account' type='text' @keyup.enter="login")
              v-text-field(v-model="password" label='Password' name='password' prepend-icon='mdi-lock' type='password' @keyup.enter="login")
          v-card-actions
            .flex-grow-1
            v-btn(color='#d93744' dark @click="login") Login
    v-snackbar.white--text.text-center(v-model="snackbar" color="red" top) {{ text }}
</template>

<script>
export default {
  name: 'Login',
  data: () => ({
    username: '',
    password: '',
    snackbar: false,
    text: 'Incorrect Username or Password!',
  }),
  methods: {
    login () {
      var data = {
        username: this.username,
        password: this.password
      }
      this.$axios.post('/admins/login/', data)
        .then(resp => {
          if(resp.data.id){
            this.$store.commit('setUser', resp.data)
            this.$store.commit('login')
          }
        })
        .catch(error => {
            this.snackbar = true
          })
    }
  }
}
</script>

<style lang="scss" scoped>

</style>